/**
 * Dispatches request processing by HTTP request method.
 *
 * @typeParam TMeans - Supported HTTP route processing means.
 * @param methods - A map of request processing handlers corresponding to HTTP request methods.
 *
 * @returns New HTTP request processing handler.
 */
export function dispatchByMethod(methods) {
    return async ({ request: { method }, next }) => {
        const verb = method ? method.toLocaleLowerCase() : 'get';
        const handler = methods[verb] || (verb === 'head' && methods.get);
        if (handler) {
            await next(handler.bind(methods));
        }
    };
}
//# sourceMappingURL=dispatch-by-method.handler.js.map